import TruckingRouteCard from './TruckingRouteCard';

export default TruckingRouteCard;
